const Scanner = () => {
    return (
    <div>
      <p>Scanner</p>
    </div>
  );
};

export default Scanner;
